import { Spinner, SpinnerSize } from "@fluentui/react";
import { PrivateRoute, routes } from "@taskpane/routes";
import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";

export const Routes = () => (
  <Suspense fallback={
    <>
      <div className="h-100 row align-items-center">
        <Spinner size={SpinnerSize.large} />
      </div>
    </>
  }>
    <Switch>
      {routes.map(({ label, path, exact, isPrivate, Component }) =>
        isPrivate ? (
          <PrivateRoute key={label} path={path} exact={exact} component={Component} />
        ) : (
          <Route key={label} path={path} exact={exact}>
            <Component />
          </Route>
        )
      )}
    </Switch>
  </Suspense>
);
